import { render, staticRenderFns } from "./babypayset.vue?vue&type=template&id=2f4deae6&scoped=true&"
import script from "./babypayset.vue?vue&type=script&lang=js&"
export * from "./babypayset.vue?vue&type=script&lang=js&"
import style0 from "./babypayset.vue?vue&type=style&index=0&id=2f4deae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4deae6",
  null
  
)

export default component.exports